import { Button } from "@/components/flowly/infra/Button/Button";

interface QuickSuggestionsProps {
  suggestions: string[];
  onSelect: (suggestion: string) => void;
  featured?: {
    label: string;
    badge?: string;
  };
}

export function QuickSuggestions({
  suggestions,
  onSelect,
  featured,
}: QuickSuggestionsProps) {
  return (
    <div className="flex flex-wrap gap-1.5">
      {featured && (
        <Button
          variant="secondary"
          size="xs"
          rounded="full"
          onClick={() => onSelect(featured.label)}
          className="relative bg-brand/10 border border-brand/30 text-brand hover:bg-brand/20 hover:border-brand/40"
        >
          {featured.label}
          {featured.badge && (
            <span className="absolute -top-2 -right-2 px-1.5 py-0.5 rounded-full bg-primary text-primary-foreground text-[10px] font-bold">
              {featured.badge}
            </span>
          )}
        </Button>
      )}
      {suggestions.map((suggestion) => (
        <Button
          key={suggestion}
          variant="secondary"
          size="xs"
          rounded="full"
          onClick={() => onSelect(suggestion)}
          className="bg-secondary/60 border border-border/60 text-foreground/70 hover:bg-brand/10 hover:border-brand/30 hover:text-foreground"
        >
          {suggestion}
        </Button>
      ))}
    </div>
  );
}
